import { render, staticRenderFns } from "./IEText.vue?vue&type=template&id=000bdf65&scoped=true"
import script from "./IEText.vue?vue&type=script&lang=js"
export * from "./IEText.vue?vue&type=script&lang=js"
import style0 from "./IEText.vue?vue&type=style&index=0&id=000bdf65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000bdf65",
  null
  
)

export default component.exports